export const styles = ({ colors }) => ({
    left: {
        left: 0,
    },
    right: {
        right: 0,
        transform: 'rotate(180deg)',
    },
    caret: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '60px',
        background: 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
    },
    caretPlaceholder: {
        width: '30px',
    },
    caretIcon: {
        fontSize: '25px',
        color: colors.white,
    },
})
